import { useGsCloudBackend } from '@gat-ship/http-client'
import type {
  AddCurrencyRequest,
  AddCurrencyPayload,
  GetLibraryCurrenciesResponse,
  GetPlatformCurrenciesResponse,
  RemoveCurrencyRequest
} from '@gat-ship/types'

export function useCurrencyApiCalls() {
  const { apiDelete, apiGet, apiPost } = useGsCloudBackend()
  async function getLibraryCurrenciesRequest() {
    const response = await apiGet<GetLibraryCurrenciesResponse>(
      'monetary/currencies/library'
    )
    return response
  }

  async function getAllPlatformCurrenciesRequest() {
    const response = await apiGet<GetPlatformCurrenciesResponse>(
      'monetary/currencies/platform'
    )
    return response
  }

  async function addCurrencyRequest(params: AddCurrencyRequest) {
    const response = await apiPost<undefined, AddCurrencyPayload>(
      'monetary/currencies/library',
      params.payload,
      params.commandId
    )
    return response
  }

  async function removeCurrencyRequest(params: RemoveCurrencyRequest) {
    const response = await apiDelete<undefined, undefined>(
      `monetary/currencies/library/${params.code}`,
      undefined,
      params.commandId
    )
    return response
  }

  return {
    getLibraryCurrenciesRequest,
    getAllPlatformCurrenciesRequest,
    addCurrencyRequest,
    removeCurrencyRequest
  }
}
